/* ============================================================
   MUSE DISC — About page JS (parallax hero bg)
   ============================================================ */
(function () {
  const bg = document.getElementById('about-hero-bg');
  if (!bg || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const hero = document.getElementById('about-hero');
  gsap.to(bg, {
    yPercent: 25,
    ease: 'none',
    scrollTrigger: {
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: 1.5,
    },
  });
})();
